export const auth = {
  field: {
    email: 'Alamat e-mail ',
    password: 'Password',
    remember_me: 'Ingatkan Aku'
  },

  button: {
    recovery_password: 'Perbaikan Password',
    create_account: 'Buat account',
    no_acc: "Don't have an account?",
    sign_up: 'Daftar',
    sign_in: 'Masuk',
    log_in: 'Gabung'
  },
  message:
    'Bagian di situs sedang diperbarui dan akan muncul nanti. Untuk mendaftar, silakan hubungi tim dukungan kami',
  phone: 'Telepon'
};
